import React from 'react';
import {
  CheckboxListItem,
  Divider,
  HStack,
  Text,
  VStack,
} from '@adc/parallax-component-library';
import { CheckboxFilterSection, CheckboxFilterItem } from '../DynamicTable';
import i18n from '../../../utilities/i18n';

export type CheckboxFilterInput = {
  id: string | number;
  value: boolean;
};

type CheckboxFilterListProps = {
  id: string | number;
  label: string;
  items: CheckboxFilterItem[];
  onChange: (id: CheckboxFilterSection['id'], item: CheckboxFilterItem) => void;
};

/**
 * Displays a list of checkbox filters.
 * @param {string | number} id - The ID of the filter section, used for updating state.
 * @param {string} label - The label of the filter section.
 * @param {CheckboxFilterItem[]} items - The list of checkbox filter items.
 * @param {function} onChange - The function to call when a checkbox is changed.
 * @returns {React.JSX.Element}
 */
export default function CheckboxFilterList({
  id,
  label,
  items,
  onChange,
}: CheckboxFilterListProps) {
  const selectedCount = items.filter((item) => item.value).length;

  return (
    <VStack width="100%">
      <HStack gap={'$2'} paddingBottom={'$2'} alignItems="center">
        <Text type={'$bodyBase.strong'}>{label}</Text>
        {selectedCount ? (
          <Text type={'$bodyBase.default'}>({selectedCount})</Text>
        ) : null}
      </HStack>
      <Divider />
      {items.length === 0 ? (
        <Text type={'$bodyBase.default'} padding={'$2'}>
          {i18n.t('Common.noData')}
        </Text>
      ) : (
        items.map((item, index) => (
          <CheckboxListItem
            key={index}
            title={item.label}
            checked={item.value}
            onPress={(checked) => onChange(id, { ...item, value: checked })}
          />
        ))
      )}
    </VStack>
  );
}
